import produce from "immer";
import reducerUtils from "../../../store/reducerUtils";
import McpServerActions from "./mcpServerActions";

const initialState = {
  data: {
    // list
    publicServers: null,
  },
};

export const mcpServerSelectors = {
  getPublicServers: (state) => state.mcpServer.data.publicServers,
};

const onPublicServersLoaded = produce((draft, action) => {
  draft.data.publicServers = action.servers;
});

const handlers = {
  [McpServerActions.PUBLIC_SERVER_LIST_LOADED]: onPublicServersLoaded,
};

const mcpServerReducer = reducerUtils.createReducer(initialState, handlers);

export default mcpServerReducer;
